export const getFileName = (fileName) => fileName.replace(/"/g, '');
